export const ServiceTypes = {
  ErrorHandler: Symbol('ErrorHandler'),
  ConfigurationService: Symbol('ConfigurationService'),
  AuthenticationService: Symbol('AuthenticationService'),
  ApiService: Symbol('ApiService'),
  GamesApiService: Symbol('GamesApiService'),
  GameStore: Symbol('GameStore'),
  BallFinalFeedService: Symbol('BallFinalFeedService'),
  LiveDashboardStore: Symbol('LiveDashboardStore'),
  LogService: Symbol('LogService'),
  SessionStore: Symbol('SessionStore'),
  PermissionService: Symbol('PermissionService'),
  PermissionStore: Symbol('PermissionStore'),
  DisplayDataStore: Symbol('DisplayDataStore'),
};
